import React, { useState } from 'react';
import { 
	OutlinedInput, 
	InputLabel, 
	InputAdornment, 
	FormControl, 
	Button 
} from '@material-ui/core';
// import { makeStyles } from '@material-ui/core/styles';
import './CalculationsPage.scss';

// const useStyles = makeStyles((theme) => ({
//   root: {
//   },
// }));

export default function InputAdornments() {
	// const classes = useStyles();
  const [payout, setPayout] = useState();
  const [nights, setNights] = useState();
  const [rate, setRate] = useState();

  const handlePayout = (e) => {
    setPayout(e.target.value)
  }

  const handleNights = (e) => {
    setNights(e.target.value)
  }

  const handleCalculations = (payout, nights) => {
		const cleaning = 375;
		const resortFee = 30.25 * nights;
		const tax = payout - (payout / 1.06);
		const base = payout - (cleaning + resortFee + tax)
		let nightlyRate = base/nights;
		setRate(nightlyRate.toFixed(2));
  }

  const handleReset = () => {
		setPayout("");
		setNights("");
		setRate("");
  }

  return (
    <div className="calculations">
      <form>
				<br />
				<div>
					<FormControl className="form-control" variant="outlined">
						<InputLabel htmlFor="airbnb-payout">Airbnb Payout</InputLabel>
						<OutlinedInput id="airbnb-payout" value={payout} onChange={handlePayout} label="Airbnb Payout" startAdornment={<InputAdornment position="start">$</InputAdornment>} />
					</FormControl>
        </div>
        <br />
        <div>
					<FormControl className="form-control" variant="outlined">
						<InputLabel htmlFor="nights">Nights</InputLabel>
						<OutlinedInput id="nights" value={nights} onChange={handleNights} label="Nights" />
					</FormControl>
				</div>
				<br />
				<div className="button-group">
					<Button className="run-button" variant="contained" color="primary" onClick={e => handleCalculations(payout, nights)}>Run</Button>
					<Button className="reset-button" variant="outlined" color="primary" onClick={handleReset}>Reset</Button>
				</div>
				<br />
				<br />
        <div>
          <FormControl className="form-control" variant="outlined">
						<InputLabel htmlFor="rate">Nightly Rate</InputLabel>
						<OutlinedInput id="rate" value={rate} label="Nightly Rate" startAdornment={<InputAdornment position="start">$</InputAdornment>} />
          </FormControl>
        </div>
      </form>
    </div>
  );
}